import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const CommentFieldWrapper = styled.div`
  margin-left: -${Spacing.S12};
`
